//
import React, { Component } from "react"
import PropTypes from "prop-types"

import {
    datePickerGenericFilter,
    textGenericFilter,
    // sorting functions
    enumValueSort,
    enumLabelSort,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    TransactionFilterableListView,
    DistrictSearchifyFLV,
    PoliticalCommitteeLegislatorSearchifyFLV,
    PoliticalCommitteeCampaignFinanceFilterableListView,
    OfficialFilterableWithoutCampaignFinanceListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    ElectionYearSelectFilter,
    FecCommitteeElectionTypeSelect,
    FecPartySelect,
} from "app/static/frontend/selects/containers/EnumSelect"

import {
    TransactionSelect,
    UpperDistrictSelect,
    LowerDistrictSelect,
    DistrictSelect,
    PoliticalCommitteeCampaignFinanceSelect,
    PoliticalCommitteeCampaignFinanceLegislatorSelect,
    OfficialWithoutCampaignFinanceSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import { generateElectionYearEnumItems } from "shared/search/helperFunctions"
import { isValidAmountStringNegative, isValidYearString } from "shared/imports/sharedHelperFunctions"
import { MAX_BILL_SEARCHIFY_SELECTIONS } from "../../constants"

export class PoliticalCommitteeElectionTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "politicalCommitteeElectionTypeFilter",
        filterKey: "committee_type__in",
        enumItems: DjangIO.app.pac.types.PoliticalCommitteeType.region_supported_items().filter(
            (item) =>
                ![
                    DjangIO.app.pac.types.PoliticalCommitteeType.nonmulticandidate_pac.value,
                    DjangIO.app.pac.types.PoliticalCommitteeType.multicandidate_pac.value,
                ].includes(item.value) && !item.label.includes("National Party Committee"),
        ),
        displayKey: "name",
        displayLabel: "Political Committee Type",
        sortBy: enumLabelSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeFecPartyTypeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "politicalCommitteeFecPartyTypeFilter",
        componentKey: "majors", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "party__in",
        enumItems: DjangIO.app.pac.types.FecParty.region_supported_items()
            // 999 comes from app/pac/types.py FecParty default_attrs.major_party_order,
            .filter(
                (item) =>
                    item.major_party_order !== 999 &&
                    ![
                        DjangIO.app.pac.types.FecParty.green_party.value,
                        DjangIO.app.pac.types.FecParty.other.value,
                    ].includes(item.value),
            ),
        sortBy: (a, b) => a.major_party_order - b.major_party_order,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PoliticalCommitteeTransactionFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={TransactionFilterableListView} {...props} />
}
PoliticalCommitteeTransactionFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
PoliticalCommitteeTransactionFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "politicalCommitteeTransactionFilter",
    filterKey: "political_committee_transaction",
    dataTypeLabel: "Transaction",
    selectComponent: TransactionSelect,
}

export class PoliticalCommitteeFECDesignationFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "politicalCommitteeFECDesignationFilter",
        filterKey: "fec_committee_designation__in",
        enumItems: DjangIO.app.pac.types.FecCommitteeDesignation.region_supported_items(),
        displayLabel: "FEC Designation",
        displayKey: "name",
        sortBy: enumLabelSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PoliticalCommitteeOfficialFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={OfficialFilterableWithoutCampaignFinanceListView} {...props} />
}
PoliticalCommitteeOfficialFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "politicalCommitteeOfficialFilter",
    filterKey: "political_committee_candidate",
    selectComponent: OfficialWithoutCampaignFinanceSelect,
}

export class PoliticalCommitteeOfficeFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "politicalCommitteeOfficeFilter",
        filterKey: "fec_committee_code__in",
        enumItems: DjangIO.app.pac.types.FecCommitteeCode.region_supported_items().filter((item) =>
            [
                DjangIO.app.pac.types.FecCommitteeCode.house.value,
                DjangIO.app.pac.types.FecCommitteeCode.presidential.value,
                DjangIO.app.pac.types.FecCommitteeCode.senate.value,
            ].includes(item.value),
        ),
        displayLabel: "Office",
        displayKey: "name",
        sortBy: enumValueSort,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export const PoliticalCommitteeCandidateDistrictFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={DistrictSearchifyFLV} {...props} />
}
PoliticalCommitteeCandidateDistrictFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "politicalCommitteeCandidateDistrictFilter",
    filterKey: "political_committee_candidate_district",
    displayLabel: "District",
    selectComponent: DistrictSelect,
}

export const PoliticalCommitteeCandidateUpperLDFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PoliticalCommitteeCandidateUpperLDFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "politicalCommitteeCandidateUpperLDFilter",
    filterKey: "political_committee_candidate_upper_ld",
    displayLabel: "Upper District",
    selectComponent: UpperDistrictSelect,
}

export const PoliticalCommitteeCandidateLowerLDFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent {...props} />
}
PoliticalCommitteeCandidateLowerLDFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "politicalCommitteeCandidateLowerLDFilter",
    filterKey: "political_committee_candidate_lower_ld",
    displayLabel: "Lower District",
    selectComponent: LowerDistrictSelect,
}

export class PoliticalCommitteeCandidateElectionYearFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "politicalCommitteeCandidateElectionYearFilter",
        filterKey: "political_committee_candidate_election_year",
        enumItems: generateElectionYearEnumItems({
            isTruncated: true,
        }),
        displayLabel: "Election Year",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
export class PoliticalCommitteeCandidateElectionYearSelectFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "politicalCommitteeCandidateElectionYearFilter",
        filterKey: "political_committee_candidate_election_year",
        enumItems: generateElectionYearEnumItems({}),
        selectComponent: ElectionYearSelectFilter,
        displayLabel: "Other Election Year",
        placeholderText: "Enter a year...",
        keyboardType: "numeric",
        shouldValidateInput: true,
        validateTextInput: isValidYearString,
        errorMessage: "Please enter a valid year.",
        // disambiguate during rendering, since uniqueFilterId is shared
        componentKey: "others",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeIsActiveFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "PoliticalCommitteeIsActiveFilter",
        filterKey: "political_committee_is_active",
        displayLabel: "Status",
        trueText: "Active",
        falseText: "Not Active",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeFecPartyTypeSelectFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        // Same uniqueFilterId as PoliticalCommitteeFecPartyTypeFilter so that the two filters share state
        // (that is, control the same section of Redux state and thus the same actual filtering).
        uniqueFilterId: "politicalCommitteeFecPartyTypeFilter",
        componentKey: "others", // disambiguate during rendering, since uniqueFilterId is shared
        filterKey: "party__in",
        enumItems: DjangIO.app.pac.types.FecParty.region_supported_items(),
        selectComponent: FecPartySelect,
        displayLabel: "Other Political Parties",
        sortBy: (a, b) => a.major_party_order - b.major_party_order,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeElectionTypeSelectFilter extends Component {
    static defaultProps = {
        filterComponent: enumGenericFilter,
        uniqueFilterId: "PoliticalCommitteeElectionTypeSelectFilter",
        filterKey: "committee_type__in",
        enumItems: DjangIO.app.pac.types.PoliticalCommitteeType.region_supported_items().filter((item) =>
            item.label.includes("National Party Committee"),
        ),
        displayKey: "name",
        sortBy: enumLabelSort,
        placeholder: "Filter for National Party Committees...",
        displayLabel: "Other Political Committees",
        selectComponent: FecCommitteeElectionTypeSelect,
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCandidateNameFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "candidateNameFilter",
        filterKey: "name_search",
        placeholderText: "Search for candidate by name...",
        displayLabel: "Name",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceReceivedMoneyFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "politicalCommitteeCampaignFinanceReceivedMoneyFilter",
        filterKey: "receipts_campaign_finance_has_contributed",
        trueText: "Yes",
        falseText: "No",
        displayLabel: "Received Money...",
        helpText: "Filter committees which have received money at least once.",
        permissions: [
            DjangIO.app.models.PermissionType.campaign_finance,
            DjangIO.app.models.PermissionType.can_access_campaign_finance,
        ],
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceDisbursedMoneyFilter extends Component {
    static defaultProps = {
        filterComponent: toggleGenericFilter,
        uniqueFilterId: "politicalCommitteeCampaignFinanceDisbursedMoneyFilter",
        filterKey: "disbursements_campaign_finance_has_contributed",
        trueText: "Yes",
        falseText: "No",
        displayLabel: "Disbursed Money...",
        helpText: "Filter committees which have disbursed money at least once.",
        permissions: [
            DjangIO.app.models.PermissionType.campaign_finance,
            DjangIO.app.models.PermissionType.can_access_campaign_finance,
        ],
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceReceiptsAmountMinFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "receiptsAmountMin",
        filterKey: "receipts_campaign_finance_amount_min",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        validateTextInput: isValidAmountStringNegative,
        displayLabel: "Receipts Amount Min",
        helpText: "Receipts amount min.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceReceiptsAmountMaxFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "receiptsAmountMax",
        filterKey: "receipts_campaign_finance_amount_max",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        displayLabel: "Receipts Amount Max",
        validateTextInput: isValidAmountStringNegative,
        helpText: "Receipts amount max.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceReceiptsDateStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "receiptsDateStart",
        filterKey: "receipts_campaign_finance_date_start",
        displayLabel: "Receipts Date From",
        helpText: "Receipts start date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceReceiptsDateEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "receiptsDateEnd",
        filterKey: "receipts_campaign_finance_date_end",
        displayLabel: "Receipts Date To",
        helpText: "Receipts end date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceDisbursementsAmountMinFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "disbursementsAmountMin",
        filterKey: "disbursements_campaign_finance_amountMin",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        validateTextInput: isValidAmountStringNegative,
        displayLabel: "Disbursed Amount Min",
        helpText: "Disbursements amount min.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceDisbursementsAmountMaxFilter extends Component {
    static defaultProps = {
        filterComponent: textGenericFilter,
        uniqueFilterId: "disbursementsAmountMax",
        filterKey: "disbursements_campaign_finance_amountMax",
        placeholderText: "$0.00",
        keyboardType: "numeric",
        shouldValidateInput: true,
        displayLabel: "Disbursed Amount Max",
        validateTextInput: isValidAmountStringNegative,
        helpText: "Disbursements amount max.",
        errorMessage: "Please enter a valid number amount.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceDisbursementsDateStartFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "disbursementsDateStart",
        filterKey: "disbursements_campaign_finance_dateStart",
        displayLabel: "Disbursed Date From",
        helpText: "Disbursements start date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceDisbursementsDateEndFilter extends Component {
    static defaultProps = {
        filterComponent: datePickerGenericFilter,
        uniqueFilterId: "disbursementsDateEnd",
        filterKey: "disbursements_campaign_finance_dateEnd",
        displayLabel: "Disbursed Date To",
        helpText: "Disbursements end date.",
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceReceiptsContributorCommitteesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "receipts_campaign_finance_receiptsContributorCommitteesFilter",
            filterKey: "receipts_contributor_committee_name",
            dataTypeLabel: "ReceiptContributorCommittee",
            searchifyFLV: PoliticalCommitteeCampaignFinanceFilterableListView,
            selectComponent: PoliticalCommitteeCampaignFinanceSelect,
            displayLabel: "Received Money From",
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceDisbursementsContributorCommitteesFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "disbursements_campaign_finance_receiptsContributorCommitteesFilter",
            filterKey: "disbursements_contributor_committee_name",
            dataTypeLabel: "ReceiptContributorCommittee",
            searchifyFLV: PoliticalCommitteeCampaignFinanceFilterableListView,
            selectComponent: PoliticalCommitteeCampaignFinanceSelect,
            displayLabel: "Disbursed Money To",
            maxSearchifySelections: MAX_BILL_SEARCHIFY_SELECTIONS,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceReceiptsLegislatorFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "politicalCommitteeCampaignFinanceReceiptsLegislatorFilter",
            filterKey: "receipts_campaign_finance_legislator_receivers",
            searchifyFLV: PoliticalCommitteeLegislatorSearchifyFLV,
            displayLabel: "Received Money From",
            dataTypeLabel: "Official",
            selectComponent: PoliticalCommitteeCampaignFinanceLegislatorSelect,
            permissions: [
                DjangIO.app.models.PermissionType.campaign_finance,
                DjangIO.app.models.PermissionType.can_access_campaign_finance,
            ],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeCampaignFinanceDisbursementsLegislatorFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "politicalCommitteeCampaignFinanceDisbursementsLegislatorFilter",
            filterKey: "disbursements_campaign_finance_legislator_receivers",
            searchifyFLV: PoliticalCommitteeLegislatorSearchifyFLV,
            displayLabel: "Disbursed Money To",
            dataTypeLabel: "Official",
            selectComponent: PoliticalCommitteeCampaignFinanceLegislatorSelect,
            permissions: [
                DjangIO.app.models.PermissionType.campaign_finance,
                DjangIO.app.models.PermissionType.can_access_campaign_finance,
            ],
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}

export class PoliticalCommitteeImportIdFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: textGenericFilter,
            uniqueFilterId: "politicalCommitteeImportIdFilter",
            filterKey: "political_committee_import_id",
            displayLabel: "Search by Import ID",
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
